// Lightweight dynamic SEO helper. Updates document title + meta tags in place.
// Works for Google (JS-rendering) and reasonable for social crawlers when
// combined with server-side prerender in the future.

const TAGS = [
  ["name", "description"],
  ["name", "keywords"],
  ["name", "twitter:card"],
  ["name", "twitter:title"],
  ["name", "twitter:description"],
  ["name", "twitter:image"],
  ["property", "og:title"],
  ["property", "og:description"],
  ["property", "og:image"],
  ["property", "og:type"],
  ["property", "og:url"],
  ["property", "og:site_name"],
];

function upsertMeta(attr, key, content) {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", String(content));
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let el = document.head.querySelector(`script[type="application/ld+json"][data-id="${id}"]`);
  if (!data) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.setAttribute("data-id", id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function setSEO({
  title,
  description = "",
  image = "",
  url = "",
  type = "website",
  keywords = "",
  siteName = "Fanpit.Club",
  jsonLd = null,
}) {
  if (title) document.title = title;

  upsertMeta("name", "description", description);
  upsertMeta("name", "keywords", keywords);

  upsertMeta("property", "og:site_name", siteName);
  upsertMeta("property", "og:title", title || siteName);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:image", image);
  upsertMeta("property", "og:type", type);
  upsertMeta("property", "og:url", url || (typeof window !== "undefined" ? window.location.href : ""));

  upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  upsertMeta("name", "twitter:title", title || siteName);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", image);

  upsertLink("canonical", url || (typeof window !== "undefined" ? window.location.href : ""));

  upsertJsonLd("primary", jsonLd);
}

export function resetSEO() {
  TAGS.forEach(([a, k]) => {
    const el = document.head.querySelector(`meta[${a}="${k}"]`);
    if (el) el.setAttribute("content", "");
  });
  upsertJsonLd("primary", null);
}
